import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const surveyBuilderRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "survey-builder/$surveyId",
}).lazy(() => import("./SurveyBuilder.lazy").then((d) => d.Route));
